import { useTranslate } from "@similarweb/i18n-provider";

import { EmployeeProfileConfirmationModal } from "../EmployeeProfileConfirmationModal/EmployeeProfileConfirmationModal";

type BulkDeleteEmployeeProfilesModalProps = {
    isOpen: boolean;
    isShared: boolean;
    count: number;
    isDeleting: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

export const BulkDeleteEmployeeProfilesModal = ({
    isOpen,
    isShared,
    count,
    isDeleting,
    onCancel,
    onConfirm,
}: BulkDeleteEmployeeProfilesModalProps) => {
    const { translate } = useTranslate();

    const descriptionKey = isShared
        ? "si.employee-profiles.delete_selected.shared.confirmation"
        : "si.employee-profiles.delete_selected.confirmation";

    return (
        <EmployeeProfileConfirmationModal
            isOpen={isOpen}
            titleKey={
                isShared
                    ? "si.employee-profiles.delete_selected.shared.title"
                    : "si.employee-profiles.delete_selected.title"
            }
            description={translate(descriptionKey, { count })}
            confirmLabel={translate(
                isShared ? "si.employee-profiles.delete.shared.confirm" : "si.common.button.delete",
            )}
            confirmButtonType="warning"
            isLoading={isDeleting}
            onCancel={onCancel}
            onConfirm={onConfirm}
            dataAutomation="bulk-delete-employee-profiles-modal"
        />
    );
};
